import { useMsal } from '@azure/msal-react';
import { useEffect } from 'react';
import logo from '../../../assets/images/brand/logo-vendmais.svg';
import { Container, Button } from './styles';


function Login() {
  const { instance } = useMsal();

  const initializeSignIn = () => {
    instance.loginRedirect();
  };

  useEffect(() => {
    initializeSignIn();
  }, []);

  return (
    <Container>
      <div className="box">

        <img src={logo} alt="Votorantim" />
        <div>Faça login para acessar os recursos</div>
        <Button
          type="Button"
          onClick={() => { initializeSignIn(); }}
        >
          Fazer Login
        </Button>
      </div>
    </Container>
  );
}

export default Login;
